import { useSeoMeta } from '@/hooks/useSeoMeta';

interface HreflangTagsProps {
  path: string;
}

/**
 * Legacy hreflang/canonical injector. After the TanStack Start cutover,
 * canonical + hreflang tags are emitted by each route's native `head()` via
 * the shared SEO helpers. This component is kept as a no-op so any residual
 * call site still compiles.
 */
export const HreflangTags = (_props: HreflangTagsProps) => null;

// Re-export the hook so callers that only imported HreflangTags for its
// side-effects can still reach the underlying data.
export { useSeoMeta };

export default HreflangTags;
